import { Injectable } from '@angular/core';
import { Issuing } from '@core/models/issuing.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface IssuingState extends EntityState<Issuing> {}

export function createInitialState(): IssuingState {
  return null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'issuings', resettable: true })
export class IssuingStore extends EntityStore<IssuingState> {
  constructor() {
    super(createInitialState());
  }
}
